import { Component } from '@angular/core';

@Component({
  selector: 'app-social-responsibility',
  templateUrl: './social-responsibility.component.html',
  styleUrl: './social-responsibility.component.scss'
})
export class SocialResponsibilityComponent {

}
